// Minimal inline stroke icons (no emoji, per the global code rule).
import type { SVGProps } from 'react';

type P = SVGProps<SVGSVGElement>;
const base = (p: P) => ({
  width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none',
  stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const,
  ...p,
});

export const IconToday = (p: P) => (
  <svg {...base(p)}><path d="M6.5 7h2M15.5 7h2M4 12h16M5 9.5v5M19 9.5v5M8 11v2M16 11v2" /></svg>
);
export const IconHistory = (p: P) => (
  <svg {...base(p)}><path d="M4 19V5M4 19h16M8 16v-4M12 16V8M16 16v-7" /></svg>
);
export const IconCoach = (p: P) => (
  <svg {...base(p)}><path d="M4 5h16v10H9l-4 4V5Z" /></svg>
);
export const IconMore = (p: P) => (
  <svg {...base(p)}><circle cx="5" cy="12" r="1.4" /><circle cx="12" cy="12" r="1.4" /><circle cx="19" cy="12" r="1.4" /></svg>
);
export const IconPlus = (p: P) => (<svg {...base(p)}><path d="M12 5v14M5 12h14" /></svg>);
export const IconMinus = (p: P) => (<svg {...base(p)}><path d="M5 12h14" /></svg>);
export const IconCheck = (p: P) => (<svg {...base(p)}><path d="M5 12l4 4L19 6" /></svg>);
export const IconSwap = (p: P) => (<svg {...base(p)}><path d="M4 8h13l-3-3M20 16H7l3 3" /></svg>);
export const IconBack = (p: P) => (<svg {...base(p)}><path d="M15 5l-7 7 7 7" /></svg>);
export const IconTrash = (p: P) => (<svg {...base(p)}><path d="M5 7h14M9 7V5h6v2M7 7l1 12h8l1-12" /></svg>);
export const IconSync = (p: P) => (<svg {...base(p)}><path d="M4 12a8 8 0 0 1 14-5l2 2M20 12a8 8 0 0 1-14 5l-2-2M18 4v5h-5M6 20v-5h5" /></svg>);
export const IconWarn = (p: P) => (<svg {...base(p)}><path d="M12 4l9 16H3L12 4ZM12 10v4M12 17.5v.5" /></svg>);
